export default __webpack_public_path__ + "static/media/Previews_29_tn.5fd6a85d.jpg";